import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Loader from "../../common/loader";
import { formateDate, showStatus } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import Breadcrums from "../../common/breadcrumbs";
import { TempleRunnerBookingDetails } from "../../services/templeRunnerBooking.services";


const ViewRunnerTempleBooking = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { id } = useParams(); // Booking ID

  const [bookingData, setBookingData] = useState(null);
  const [loading, setLoading] = useState(true);

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Temple Bookings"), url: "/admin/runner-booking/list/1" },
    { title: t("View"), url: "" },
  ];

  useEffect(() => {
    if (!id) return;

    setLoading(true);
    TempleRunnerBookingDetails(id)
      .then((res) => {
        if (res && res.data) setBookingData(res.data);
      })
      .catch((err) => console.error("Error fetching booking details:", err))
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) return <Loader />;

  if (!bookingData) return <div className="text-center">No data found</div>;

  const { temple, service, charges, extra_member, runner, booking_user, family_member } = bookingData;

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="main-content-label mb-3">{t("View Temple Booking")}</h6>

              <div className="row">
                <div className="col-lg-12 form-group">
                  <table className="table table-bordered table-hover">
                    <tbody>
                      <tr>
                        <th>{t("Temple Name")}</th>
                        <td>{temple?.templeName || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>{t("Temple Location")}</th>
                        <td>{temple?.templeLocation || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>{t("Temple Description")}</th>
                        <td>{temple?.templeDesc || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>{t("Temple Status")}</th>
                        <td>{temple?.status ? "Active" : "Inactive"}</td>
                      </tr>
                      {temple?.templeImage && (
                        <tr>
                          <th>{t("Temple Image")}</th>
                          <td>
                            <img
                              src={temple.templeImage}
                              alt="Temple"
                              style={{ width: "150px", height: "auto", borderRadius: "6px", border: "1px solid #ddd" }}
                            />
                          </td>
                        </tr>
                      )}
                      <tr>
                        <th>{t("Service Name")}</th>
                        <td>{service?.name || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>{t("Duration")}</th>
                        <td>{service?.duration ? `${service.duration} Minutes` : "N/A"}</td>
                      </tr>

                      {/* Extra Member */}
                      {extra_member?.name && (
                        <tr>
                          <th>{t("Extra Member")}</th>
                          <td>
                            Name : {extra_member.name} - Nakshatra : {extra_member.nakshatra} | Rashi : {extra_member.rashi}
                          </td>
                        </tr>
                      )}
                      <tr>
                        <th>{t("Runner")}</th>
                        <td>{runner?.name || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>{t("Booking User")}</th>
                        <td>{booking_user?.name || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>{t("Family Member")}</th>
                        <td>{family_member?.name || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>{t("Booking Status")}</th>
                        <td>{bookingData.order_status}</td>
                      </tr>
                      <tr>
                        <th>{t("Payment Status")}</th>
                        <td>{bookingData.payment_status || "N/A"}</td>
                      </tr>

                      {/* Date & Time */}
                      <tr>
                        <th>{t("Booking Date & Time")}</th>
                        <td>
                          {bookingData.puja_date
                            ? `${formateDate(bookingData.puja_date)} ${bookingData.puja_time || ""}`
                            : "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="ml-4 back-button mx-0 mt-3">
              <button className="btn ripple btn-dark" type="button" onClick={() => navigate("/admin/temple-booking/list/1")}>
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewRunnerTempleBooking;
